import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { getPortfolioTransactionPath } from '../../../../../../../../../features/portfolio/transaction/portfolio-transaction-routing';
import { AccountBreadcrumb } from '../../../../../../../../../features/registration/account/account-breadcrumb';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account/_detail/transaction/_transaction')({
  loader: ({ params }) =>
    ({
      breadcrumb: buildBreadcrumb({
        id: `account-${params.accountId}-transaction-list`,
        label: <AccountBreadcrumb accountId={params.accountId} />,
        inactiveLabel: <AccountBreadcrumb accountId={params.accountId} displayIdOnly />,
        to: getPortfolioTransactionPath({ kind: 'list', keys: { accountId: params.accountId } }),
      }),
    }) satisfies AggregateBreadcrumb,
});
